import styled from "@emotion/styled";
import {
  ActionIcon,
  type ActionIconProps,
  createPolymorphicComponent,
  type MantineThemeOverride,
  TextInput,
} from "@mantine/core";

export const GroupItemContainer = styled.div`
  position: relative;
  margin: 3% 10%;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 6px;
  border: 1px solid
    ${({ theme }) => (theme.colorScheme === "dark" ? "#222" : "#ddd")};
  background-color: ${({ theme }) => theme.colors.logbookSectionBg[0]};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 0px 1px;
  cursor: pointer;
  transition: box-shadow 0.3s;
  ${({ active, theme }: { active?: boolean; theme?: MantineThemeOverride }) =>
    active && `box-shadow: ${theme?.colors?.cardBoxShadow?.[0]} 0px 3px 18px;`}
`;

export const GroupNameInput = styled(TextInput)`
  font-size: 20px;
  padding-bottom: 1px;
  width: 200px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.settingsColor};
`;

const _DeleteBox = styled(ActionIcon)`
  position: absolute;
  top: 8px;
  right: 8px;
`;

export const DeleteBox = createPolymorphicComponent<"button", ActionIconProps>(
  _DeleteBox,
);
